var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-referral content-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3" },
        [
          _vm.referralCodeOwner
            ? _c("div", { staticClass: "card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body text-center" },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: _vm.referralCodeOwner.picture,
                          expression: "referralCodeOwner.picture"
                        }
                      ],
                      staticClass: "rounded-circle user-img-ref",
                      attrs: { width: "120" }
                    }),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm._f("firstName")(_vm.referralCodeOwner.full_name)
                        ) +
                          " " +
                          _vm._s(
                            _vm.$t("message.promotion.give_you_referral_code")
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("span", { staticClass: "ref-code" }, [
                      _vm._v(_vm._s(_vm.$route.query.c))
                    ]),
                    _vm._v("  \n          "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _vm.refCode,
                            expression: "refCode",
                            arg: "copy"
                          }
                        ],
                        staticClass: "button button-large -yellow",
                        on: { click: _vm.copyReferralCode }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(_vm.isCopiedReferralCode)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "text-primary",
                        attrs: { to: "/booking/start", tag: "a" }
                      },
                      [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("message.hero.action_button")))
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.no_data")) + "\n      "
                )
              ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/bg-invite.jpg", alt: "" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-539881d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539881d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/referral/Index.vue
// module id = 1960
// module chunks = 0